import { ChatRoomItemTypeMessageWebSocket, type ConfirmEventMessageWebSocket } from "../Models/WebSocket";
import { MessageTypeWebSocket } from "../Models/WebSocket";
import { ChatRoomItemType, type TextChatRoomItem } from "../Models/Domain/Chat";

import useChatStore from "@/Modules/Chat/Store";

function ConfirmReceiveMessageActionHandler(chatId: string, messageId: string): ConfirmEventMessageWebSocket {
  const chatStore = useChatStore();
  const statusEventPayload: ConfirmEventMessageWebSocket = {
    chat: chatId,
    rd_eid: messageId,
    nonce: `${Date.now() + Math.floor(Math.random() * 1000)}`,
    etype: ChatRoomItemTypeMessageWebSocket.CONFIRMATION,
    type: MessageTypeWebSocket.CHAT_ROOM_ITEM,
  };

  chatStore.socketManager?.sendMessage(statusEventPayload);

  if (chatStore.rooms[chatId]) {
    const index = chatStore.rooms[chatId].events.findIndex((e) => e.id === messageId);

    if (index !== -1 && chatStore.rooms[chatId].events[index].type !== ChatRoomItemType.OUTGOING_TEXT) {
      (chatStore.rooms[chatId].events[index] as TextChatRoomItem).isReceived = true;
    }
  }

  return statusEventPayload;
}

export default ConfirmReceiveMessageActionHandler;
